'use strict'
import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll()

export default function (fixedMenuHeight) {
	const url = new URL(window.location.href)
	const scrollToValue = url.searchParams.get('scrollTo')

	if (scrollToValue) {
		const scrollToElement = document.querySelector(`#${scrollToValue}`)
		const siteWrapper = document.querySelector('.site-wrapper')
		if (window.innerWidth > 1200) {
			scroll.animateScroll(scrollToElement, null, {
				offset: fixedMenuHeight,
				speed: 1000
			})
		} else {
			siteWrapper.scrollTo(0, scrollToElement.getBoundingClientRect().top + siteWrapper.scrollTop - 70)
		}
	}

	[...document.querySelectorAll('a[data-scroll-to]')].forEach(link => {
		link.addEventListener('click', e => {
			if (window.location.pathname.includes('dla-klienta')) {
				e.preventDefault()
				let newLink = new URL(link.href).searchParams.get('scrollTo')

				scroll.animateScroll(document.querySelector('#' + newLink), null, {
					offset: fixedMenuHeight,
					speed: 1000
				})
			}
		})
	})
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollToElement.js